//메인화면 메뉴리스트
import {Link} from "react-router-dom";

//MUI
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, Checkbox, Container, Grid, TextField, Typography } from '@mui/material';

import UBreadCrumbs from "../../mui/UBreadCrumbs";
import UButton from "../../mui/UButton";

const ContentDetail = (props) => {
    const detail = props.detail;
    const onButtonClick = props.onButtonClick;
    const  onDetailChange = props.onDetailChange;
    return(
        <>
        <div class="DetailBox" style={{ paddingBlockStart: "20px" , display: "grid"}}>
            <Container maxWidth={false}>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    m: -1
                }}
                >
                <UBreadCrumbs subtitle="상세조회" />
                <Box sx={{ m: 1 }}>
                    <UButton onButtonClick={props.onButtonClick}>저장</UButton>
                    <UButton onButtonClick={props.onButtonClick}>삭제</UButton>
                    <UButton onButtonClick={props.onButtonClick}>취소</UButton>
                </Box>
            </Box>
            </Container>
            <Card>
                <CardContent>
                    <Grid
                        container
                        spacing={3}
                    ><Grid
                        item
                        md={3}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>First Name</Typography>
                        <TextField
                            fullWidth
                            name="firstName"
                            onChange={props.onDetailChange}
                            required
                            value={props.detail.firstName}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={3}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>First Name</Typography>
                        <TextField
                            fullWidth
                            name="firstName"
                            onChange={props.onDetailChange}
                            required
                            value={props.detail.firstName}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={6}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>Last Name</Typography>
                        <TextField
                            fullWidth
                            name="lastName"
                            onChange={props.onDetailChange}
                            required
                            value={props.detail.lastName}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={6}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>Last Name</Typography>
                        <TextField
                            fullWidth
                            label="Email Address"
                            name="email"
                            onChange={props.onDetailChange}
                            required
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={6}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>Last Name</Typography>
                        <TextField
                            fullWidth
                            label="Phone Number"
                            name="phone"
                            onChange={props.onDetailChange}
                            type="number"
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={6}
                        xs={12}
                        >
                        <Typography variant="subtitle1" sx={{ display: "flex",justifyContent: "left",}}>Last Name</Typography>
                        <TextField
                            fullWidth
                            label="Country"
                            name="country"
                            onChange={props.onDetailChange}
                            required
                            variant="outlined"
                        />
                        </Grid>
                        <Grid
                        item
                        md={4}
                        sm={6}
                        sx={{
                        display: 'flex',
                        flexDirection: 'column'
                        }}
                        xs={12}
                    >
                        <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            ml: -1
                        }}
                        >
                        <Checkbox
                            name="policy"
                        />
                        <Typography
                            color="textSecondary"
                            variant="body2"
                        >
                            I have read the
                            
                        </Typography>
                        </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            


        </div>
        {/* Detail End */}
        </>
    );
}

export default ContentDetail;
